import { useEffect, useRef, useState } from 'react';

type ScrollState = 'idle' | 'down' | 'up';

interface Options {
    threshold?: number;
    delay?: number;
    throttleMs?: number;
    forceHide?: boolean;
}

export function useScrollDirection({ threshold = 2, delay = 3000, throttleMs = 150, forceHide = false }: Options): { showWidget: boolean } {
    const [showWidget, setShowWidget] = useState(true);

    const lastScrollY = useRef(0);
    const lastRun = useRef(0);
    const timer = useRef<number | null>(null);

    const scrollState = useRef<ScrollState>('idle');
    const idleFromTimer = useRef(false); // 🔑 关键标记

    useEffect(() => {
        if (typeof window === 'undefined') return;

        lastScrollY.current = window.scrollY;

        const clearTimer = () => {
            if (timer.current !== null) {
                clearTimeout(timer.current);
                timer.current = null;
            }
        };

        const handleScroll = () => {
            const now = Date.now();
            if (now - lastRun.current < throttleMs) return;
            lastRun.current = now;

            const currentY = window.scrollY;
            const diff = currentY - lastScrollY.current;

            if (Math.abs(diff) < threshold) return;

            // =========================
            // idle 状态特殊处理
            // =========================
            if (scrollState.current === 'idle') {
                if (diff > 0) {
                    // 🔽 向下
                    if (idleFromTimer.current) {
                        // timer 结束后的残余向下，忽略一次
                        idleFromTimer.current = false;
                    } else {
                        // ✅ 第一次真实向下
                        scrollState.current = 'down';
                        setShowWidget(false);

                        // clearTimer();
                        // timer.current = window.setTimeout(() => {
                        //     scrollState.current = 'idle';
                        //     idleFromTimer.current = true;
                        //     setShowWidget(true);
                        // }, delay);
                    }
                } else {
                    // 🔼 向上
                    idleFromTimer.current = false;
                    scrollState.current = 'up';
                    setShowWidget(true);
                }

                lastScrollY.current = currentY;
                return;
            }

            // =========================
            // 非 idle 状态
            // =========================
            // clearTimer();

            if (diff > 0) {
                // 🔽 向下
                scrollState.current = 'down';
                setShowWidget(false);

                // timer.current = window.setTimeout(() => {
                //     scrollState.current = 'idle';
                //     idleFromTimer.current = true;
                //     setShowWidget(true);
                // }, delay);
            } else {
                // 🔼 向上
                idleFromTimer.current = false;
                scrollState.current = 'up';
                setShowWidget(true);
            }

            lastScrollY.current = currentY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
            clearTimer();
        };
    }, [threshold, delay, throttleMs]);

    // 🔴 外部强制隐藏（最高优先级）
    useEffect(() => {
        if (forceHide) {
            setShowWidget(false);
        }
    }, [forceHide]);

    return { showWidget };
}
